import React, { ReactNode } from 'react';
import { BoxAuthCard } from './BoxAuthCard';
import { Button, Icon, Typography } from '../common';
import Icons from '@/const/icons';
import Image from 'next/image';
import Images from '@/const/images';
import clsx from 'clsx';

interface Props {
	srcImage: string | undefined;
	title: string | ReactNode;
	children: ReactNode;
	classNameTitle?: string;
	handleBack: () => void;
}

export const ResetCard: React.FC<Props> = ({
	title,
	classNameTitle,
	handleBack,
	srcImage,
	children,
}) => {
	return (
		<BoxAuthCard className="lg:w-[762px] !p-8 space-y-8">
			<Button
				decoration="ghost"
				className="space-x-3 !p-0"
				size="fit"
				onClick={handleBack}
			>
				<Icon src={Icons.arrowLeft} className="!size-6" />
				<Typography type="semibold-18">Return to Sign In</Typography>
			</Button>
			<Image
				src={Images.logoSVG}
				alt="Logo"
				width={199}
				height={38}
				className="mx-auto"
			/>
			{srcImage && (
				<Image
					src={srcImage}
					alt=""
					width={138}
					height={138}
					className="mx-auto"
				/>
			)}
			<Typography
				type="custom-h1"
				className={clsx(
					'text-[40px] text-center font-bold leading-tight',
					classNameTitle
				)}
			>
				{title}
			</Typography>
			{children}
		</BoxAuthCard>
	);
};
